<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h410_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogAddEditViewForm"
        :model="dialogAddEditViewForm"
        :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item
                  label="人员类型"
                  prop="type"
                >
                  <el-radio-group
                    v-model="dialogAddEditViewForm.type"
                    :disabled="eventType==='view'"
                    @change="changeTypeFun"
                  >
                    <el-radio :label="1">
                      临时促销人员
                    </el-radio>
                    <el-radio :label="2">
                      礼仪
                    </el-radio>
                    <el-radio :label="3">
                      主持
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="人员名称"
                  prop="userName"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.userName"
                    disabled
                  >
                    <el-button
                      slot="append"
                      icon="el-icon-search"
                      @click="handleUser()"
                    />
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="保单号"
                  prop="policyNo"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.policyNo"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="分单号"
                  prop="splitNo"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.splitNo"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="保单客户号码"
                  prop="userNo"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.userNo"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="有效开始日期"
                  prop="startDate"
                >
                  <el-date-picker
                    v-model="dialogAddEditViewForm.startDate"
                    type="date"
                    style="width: 100%;"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :disabled="eventType === 'view'"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="退保日期"
                  prop="endDate"
                >
                  <el-date-picker
                    v-model="dialogAddEditViewForm.endDate"
                    type="date"
                    style="width: 100%;"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :disabled="eventType !== 'edit'"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="modal-box">
          <h3 class="modal-title">
            备注信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item prop="remark">
                  <el-input
                    v-model="dialogAddEditViewForm.remark"
                    type="textarea"
                    placeholder="备注"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
    <!-- 人员列表 -->
    <employee-list-dialog
      :dialog-visible.sync="dialogEmployeeVisible"
      dialog-title="人员信息"
      @selectedEmployeeFun="selectedEmployeeFun"
    />
    <!-- 外聘人员列表 -->
    <external-employee-list-dialog
      :dialog-visible.sync="dialogExternalEmployeeVisible"
      :employee-type="showType"
      dialog-title="外聘人员信息"
      @selectedExternalEmployeeFun="selectedEmployeeFun"
    />
  </div>
</template>
<script>
// dialog拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 选择人员
import employeeListDialog from './employeeListDialog'
// 选择外聘人员
import externalEmployeeListDialog from './externalEmployeeListDialog'
// 保单API
import { saveUserInsurancePolicyApi, viewUserInsurancePolicyApi } from '@/api/v2/userInsurancePolicy';

export default {
  components: {employeeListDialog, externalEmployeeListDialog},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        type: [{ required: true, message: '请选择人员类型', trigger: 'blur' }],
        userName: [{ required: true, message: '请选择人员', trigger: 'blur' }],
        policyNo: [{ required: true, message: '请输入保单号', trigger: 'blur' }],
        splitNo: [{ required: true, message: '请输入分单号', trigger: 'blur' }],
        userNo: [{ required: true, message: '请输入保单客户号码', trigger: 'blur' }],
        startDate: [{ required: true, message: '请选择有效开始日期', trigger: 'change' }],
        bankName: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }],
        bankNo: [{ max: 64, message: '最多输入64个字符', trigger: 'blur' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }]
      },
      showType: 0,
      dialogEmployeeVisible: false,
      dialogExternalEmployeeVisible: false
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;
        _this.dialogAddEditViewForm = {
          type: 1,
          userName: '',
          userId: '',
          policyNo: '',
          splitNo: '',
          userNo: '',
          startDate: '',
          endDate: '',
          remark: ''
        }
        if (_this.eventType !== 'add') {
          _this.loadUserInsurancePolicyData()
        }

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditViewForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    loadUserInsurancePolicyData () {
      let _this = this;
      viewUserInsurancePolicyApi({ id: _this.dataId }).then((response) => {
        const { data } = response
        for (let key in _this.dialogAddEditViewForm) {
          _this.dialogAddEditViewForm[key] = data[key]
        }
        _this.dialogAddEditViewForm.id = data.id
      })
    },
    // 变更人员类型
    changeTypeFun(){
      this.dialogAddEditViewForm.userId = ''
      this.dialogAddEditViewForm.userName = ''
    },
    // 选择人员信息
    handleUser(){
      let _this = this;
      _this.showType = 0
      if(_this.dialogAddEditViewForm.type === 1){
        _this.dialogEmployeeVisible = true
      } else {
        if(_this.dialogAddEditViewForm.type === 2){
          _this.showType = 1
        } else {
          _this.showType = 2
        }
        _this.dialogExternalEmployeeVisible = true
      }
    },
    // 选择后人员回调
    selectedEmployeeFun(val){
      let _this = this;
      _this.dialogAddEditViewForm.userId = val.id
      _this.dialogAddEditViewForm.userName = val.name
    },
    // 新增|修改保存
    handleSave () {
      let _this = this;
      _this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          _this.$confirm(
            (_this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '人员保单信息', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
              saveUserInsurancePolicyApi(_this.dialogAddEditViewForm).then(() => {
                _this.$message({ message: '保存成功', type: 'success' })
                _this.$emit('reloadData')
                _this.modalClose()
              }).catch(() => { })
            }).catch(() => { })
        }
      })
    },
    modalClose () {
      this.$emit('update:dialogVisible', false)
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
  }
}
</script>
<style lang="scss"  scoped>
</style>
